import { render, staticRenderFns } from "./TextAndButton.vue?vue&type=template&id=dd242612&"
import script from "./TextAndButton.vue?vue&type=script&lang=ts&"
export * from "./TextAndButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports